import { Injectable } from '@angular/core';
import { ConsumeService } from './consume.service';
import { Endpoints } from 'src/environments/endpoints';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BitlyService {

  constructor(private consumeService: ConsumeService) { }

  generateShortUrl(body: any) {
    return this.consumeService.httpPost(`${Endpoints.bitly.shortenLink}`, body, {'Authorization': `Bearer ${environment.bitly.accesToken}`})
  }
}
